import { LocaleSchema } from "./locales";

const isLocalizedText = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" &&
  value !== null &&
  !Array.isArray(value) &&
  Object.keys(value).length > 0 &&
  Object.entries(value).every(
    ([locale, text]) => LocaleSchema.safeParse(locale).success && (typeof text === "string" || text === null)
  );

export const dropBlankTranslations = (_key: string, value: unknown) => {
  if (!isLocalizedText(value)) return value;
  const kept = Object.entries(value).filter(([, text]) => typeof text === "string" && text.trim() !== "");
  return kept.length > 0 ? Object.fromEntries(kept) : null;
};
